import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function AddAcceso({ onNewAcceso, editAcceso }) {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [nombreAcceso, setNombreAcceso] = useState('');
    const [idMenu, setIdMenu] = useState('');
    const [estado, setEstado] = useState(true);
    const [menus, setMenus] = useState([]);
    const { user } = useUser();
    const [modificacion, setModificacion] = useState(1);

    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString();
        fechaISO = fechaISO.slice(0, -1);
        return fechaISO;
    }

    const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        fetchMenus();
        if (editAcceso) {
            console.log(editAcceso);
            setNombreAcceso(editAcceso.nombreacceso);
            console.log(editAcceso.nombreAcceso);
            setIdMenu(editAcceso.id_menu);
            setEstado(editAcceso.estado);
            setModificacion(2);
        } else {
            setNombreAcceso('');
            setIdMenu('');
            setEstado(true);
            setModificacion(1);
        }
    }, [editAcceso]);

    const fetchMenus = async () => {
        try {
            const response = await fetch(`${server}/sg_menu`);
            const data = await response.json();
            setMenus(data.$values);
            console.log(data.$values);
        } catch (error) {
            console.error('Error al cargar los menús:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const usuario = user ? user.codigoUsuario : 'Desconocido';

        let acceso;
        
        if (editAcceso) {
            acceso = {
            id: editAcceso.id,
            nombreacceso: nombreAcceso,
            id_menu: idMenu,
            estado,
            modificadoPor: usuario
            };
        } else {
            acceso = {
            nombreacceso: nombreAcceso,
            id_menu: idMenu,
            estado,
            ingresadoPor: usuario
            };
        }

        const endpoint = editAcceso ? `${server}/sg_acceso/${editAcceso.id}` : `${server}/sg_acceso`;
        const method = editAcceso ? 'PUT' : 'POST';
        console.log(acceso);
        console.log(endpoint);
        try {
            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(acceso),
            });

            if (response.ok) {
                alert('Acceso cargado con éxito');
                onNewAcceso();
            } else {
                alert('Error al agregar el acceso');
            }
        } catch (error) {
            console.error('Error al agregar el acceso:', error);
            alert('Error al agregar el acceso');
        }
    };

    return (
        <>
            <h2>{editAcceso ? 'Editar Acceso' : 'Agregar Nuevo Acceso'}</h2>
            <br />
            <form id="Accesos" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="nombreAcceso">
                        Nombre Acceso: <span className="required">*</span>
                    </label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="nombreAcceso"
                            required="required"
                            className="form-control"
                            value={nombreAcceso}
                            onChange={(e) => setNombreAcceso(e.target.value)}
                        />
                    </div>
                </div>
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="idMenu">Menú</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={idMenu} onChange={(e) => setIdMenu(e.target.value)}>
                            <option value="">Elija una opción</option>
                            {menus.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.nombre_menu}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align">
                        Estado:
                    </label>
                    <div className="col-md-1 col-sm-6">
                        <input
                            type="checkbox"
                            id="estado"
                            checked={estado}
                            onChange={(e) => setEstado(e.target.checked)}
                        /> Activo
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button className="btn btn-primary" type="reset">Limpiar</button>
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Acceso')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddAcceso;
